import React, { useState, useEffect, useRef } from 'react';
import "react-data-table-component-extensions/dist/index.css";
import { Link, useLocation } from 'react-router-dom';
import DataTable from 'react-data-table-component';
import DataTableExtensions from "react-data-table-component-extensions";
import Select from 'react-select';
import 'react-accessible-accordion/dist/fancy-example.css';
import 'react-quill/dist/quill.snow.css'
import { Redirect } from 'react-router-dom';
import 'react-base-table/styles.css'
import { getTokenInfo } from '../../UseToken';
import UseSidebar from '../../UseSidebar';

import { api_crud_base, api_crud_route, api_list_route, data_interface, endpoints } from './Config';

import 'react-phone-number-input/style.css'

import Swal from 'sweetalert2'
import Loader from '../Loader/Loader';

import {

    reqGET,
    reqPOST,
    reqDELETE,
    reqPUT,
    reqFILE,
    set_language,
    content_language,
    check_interface,

} from '../../Utils';

import { language } from './Language';
import { color } from "../WEBContent/Color";
import { icon } from "../WEBContent/Icon";

export default function List() {
    const [, set_dados] = useState(null);
    const permissions = useRef(null);

    const [document_state_list, set_document_state_list] = useState([])

    const [data, setData] = useState([]);
    const [isloading, setLoading] = useState(true);
    const [filteredData, setFilteredData] = useState([]);
    const [lang, set_lang] = useState('pt');

    const { pathname } = useLocation()
    // const [permissions, set_permissions] = useState({})

    const handleRowClick = (id) => {
        document.getElementById('c_' + id)?.click();
    };

    const get_info = async () => {
        //await reqGET(api_list_route(getTokenInfo().companycode))
        await reqGET(api_list_route(getTokenInfo().companycode))
            .then(res => {
                if (res.data[0] !== undefined)
                    setData(res.data);
            })
            .catch(() => 404
            )
    }

    let get_permissions = async (e, sidebar) => {
        let handleSingleCheck = async (e, sidebar) => {
            const name = e;

            let ver_submenu = async (node) => {
                if (node.submenu.length !== 0) {

                    // node.submenu.forEach(subitem => {
                    for await (let subitem of node.submenu) {

                        if (subitem.path === name) {

                            let aux = {}
                            if (permissions.current !== null) {
                                aux = permissions.current

                                if (aux.create !== true) {
                                    aux.create = subitem.create
                                }
                                if (aux.edit !== true) {
                                    aux.edit = subitem.edit
                                }
                                if (aux.remove !== true) {
                                    aux.remove = subitem.remove
                                }
                            }
                            else {
                                aux = { create: subitem.create, edit: subitem.edit, view: true, remove: subitem.remove }
                            }

                            // set_permissions({ edit: subitem.edit, view: true, remove: subitem.remove })
                            set_dados(permissions.current = aux)
                        }
                        else {
                            await ver_submenu(subitem)
                        }

                    }
                }
            }

            // sidebar.forEach(node => {
            for await (let node of sidebar) {
                if (node.path === name) {

                    let aux = {}
                    if (permissions.current !== null) {
                        aux = permissions.current

                        if (aux.create !== true) {
                            aux.create = node.create
                        }
                        if (aux.edit !== true) {
                            aux.edit = node.edit
                        }
                        if (aux.remove !== true) {
                            aux.remove = node.remove
                        }
                    }
                    else {
                        aux = { create: node.create, edit: node.edit, view: true, remove: node.remove }
                    }

                    // set_permissions({ edit: node.edit, view: true, remove: node.remove })
                    set_dados(permissions.current = aux)

                    if (Array.isArray(node.submenu) && node.submenu.length > 0) {
                        await ver_submenu(node)
                    }

                } else
                    await ver_submenu(node)
            }
        }

        await handleSingleCheck(e, sidebar)
    }

    useEffect(() => {

        (async () => {

            let aux_document_state = [
                {
                    id: 0,
                    label: 'Em edição'
                },
                {
                    id: 1,
                    label: 'Aguarda aprovação'
                },
                {
                    id: 2,
                    label: 'Em revisão'
                },
                {
                    id: 3,
                    label: 'Aprovado'
                },
                {
                    id: 4,
                    label: 'Obsoleto'
                },
                {
                    id: 5,
                    label: 'Eliminado'
                }
            ]
            set_document_state_list(aux_document_state)

            await get_info()

            set_lang(localStorage.getItem('lang'))

            await UseSidebar().getSidebar(getTokenInfo().profile).then(async (v) => { await get_permissions(pathname, v) })

            if (getTokenInfo().entity_profile !== undefined && Array.isArray(getTokenInfo().entity_profile)) {

                for await (let el of getTokenInfo().entity_profile) {
                    await UseSidebar().getSidebarEntity(el.name).then(async (v) => { await get_permissions(pathname, v) })
                }

            }

            setLoading(false)

        })()

    }, [pathname]);

    useEffect(() => {
        const userId = String(getTokenInfo().id);

        const filtered = data.filter(event => {
            const isLembrete =
                event?.info?.event_type?.name === 'Lembrete';

            const creatorId =
                event?.info?.createadBy?.[0]?.id;

            const isOwner = String(creatorId) === userId;

            return !isLembrete || isOwner;
        });

        console.log('Filtered Data:', filtered);
        setFilteredData(filtered);
    }, [data]);

    console.log('Filtered Data:', data);

    //APAGAR REGISTO
    function apagar(id) {

        Swal.fire({
            title: language[lang].delete_title,
            text: language[lang].delete_text,
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#0095e8',
            cancelButtonColor: '#d9214e',
            confirmButtonText: language[lang].delete_confirm,
            cancelButtonText: language[lang].delete_cancel
        })
            .then((result) => {
                if (result.isConfirmed) {
                    reqDELETE(api_crud_route, { id: id })
                        .then(res => {
                            //props.history.push(endpoints.list);
                        })
                        .catch(error => console.log(error))
                }
            })
    }

    const columns = [
        {
            name: language[lang].id,
            selector: row => row?.id || '',
            width: '7% !important',
            minWidth: '100px !important',
            sortable: true,
            left: true,
        },
        {
            name: language[lang].title,
            selector: row => {
                if (lang === 'en') {
                    return row.info?.title?.[0]?.en || '';
                }
                return row.info?.title?.[0]?.pt || '';
            },
            width: '10% !important',
            minWidth: '200px !important',
            sortable: true,
            left: true,
        },
        {
            name: language[lang].date,
            selector: row => row.info?.date || '',
            width: '10% !important',
            minWidth: '200px !important',
            sortable: true,
            left: true,
        },
        {
            name: language[lang].time,
            selector: row => row.info?.time || '',
            width: '10% !important',
            minWidth: '200px !important',
            sortable: true,
            left: true,
        },
        {
            name: language[lang].field_location,
            selector: row => row.info?.location || '',
            width: '10% !important',
            minWidth: '200px !important',
            sortable: true,
            left: true,
        },
        {
            name: language[lang].description,
            selector: row => {
                if (Array.isArray(row.info?.description) && row.info.description.length > 0) {
                    return row.info.description.map(d => d[lang] || d.pt || '').join(', ');
                }
                return '';
            },
            width: '18% !important',
            minWidth: '250px !important',
            sortable: true,
            left: true,
        },
        {
            name: language[lang].field_activo,
            selector: row => (
                row.info.active ?
                    <span className="badge rounded bg-success p-0">
                        <i className="bi bi-check text-white fs-4"></i>
                    </span>
                    :
                    <span className="badge rounded bg-danger p-0">
                        <i className="bi bi-x text-white fs-4"></i>
                    </span>
            ),
            width: '7% !important',
            minWidth: '120px !important',
            sortable: true,
            left: true,
        },
        {
            name: language[lang].field_prioridade,
            selector: row => row.info?.prioridade || '',
            width: '10% !important',
            minWidth: '150px !important',
            sortable: true,
            left: true,
        },
        {
            name: language[lang].event_type,
            selector: row => row.info?.event_type?.name || '',
            width: '10% !important',
            minWidth: '180px !important',
            sortable: true,
            left: true,
        },
        {
            name: '',
            right: true,
            export: false,
            print: false,
            width: '7% !important',
            minWidth: '150px !important',
            cell: row => (
                <span>
                    <Link
                        id={'c_' + row.id}
                        className="button button-update button-view d-none"
                        to={{ pathname: endpoints.view, state: { item: row, operation: 'view' } }}
                        replace
                    >
                        <i className={icon.view.className} style={icon.view.style}></i>
                        <span className="tooltiptext" style={{ fontSize: '12px', padding: '4px 6px' }}>
                            {language[lang].view}
                        </span>
                    </Link>

                    <Link
                        className={permissions.current != null && permissions.current.edit ? "button button-update" : "d-none"}
                        to={{ pathname: endpoints.regist, state: { item: row, operation: 'edit' } }}
                        replace
                    >
                        <i className={icon.pencil.className} style={icon.pencil.style}></i>
                        <span className="tooltiptext" style={{ fontSize: '12px', padding: '4px 6px' }}>
                            {language[lang].edit}
                        </span>
                    </Link>

                    {permissions.current.remove ? (
                        <button
                            onClick={() => apagar(row.id)}
                            className="button btn-delete"
                            style={{ display: 'none' }}
                        >
                            <i className="bi bi-trash"></i>
                        </button>
                    ) : null}
                </span>
            )
        },
    ];

    const defaultComponentOptions = {
        rowsPerPageText: language[lang].table_rows_per_page,
        rangeSeparatorText: language[lang].table_separator,
        noRowsPerPage: false,
        selectAllRowsItem: false,
        selectAllRowsItemText: language[lang].table_all,
    };


    const tableData = {
        columns,
        data: filteredData,
        filterPlaceholder: language[lang].filter_placeholder,
        export: false,
        print: false
    };

    return (isloading ?

        <Loader />

        :

        <main>
            <div className={`dash-cards header`}>
                <div className="container">
                    <h2 className="dash-title">{language[lang].component_list}</h2>
                    <p>{language[lang].component} / {language[lang].component_list}</p>
                </div>
            </div>

            <div className={`dash-cards body`}>
                <div className="container">

                    <div className="card mb-5 mb-xl-8">
                        <div className="card-body">
                            <div className="pb-10">
                                <div className="div-table">
                                    {(permissions.current !== null && permissions.current.create) && (
                                        <div className="table-header text-end mb-8">
                                            <Link className="btn rounded-pill btn-primary py-1 px-4 multi-item"
                                                to={{ pathname: endpoints.regist }}
                                                style={{ padding: '0.15rem 1.0rem', fontSize: '0.9rem' }}
                                            >
                                                <span>{language[lang].add_new}</span>
                                            </Link>
                                        </div>
                                    )}
                                    <div className="table-body">
                                        <DataTableExtensions {...tableData}>
                                            <DataTable
                                                noDataComponent={language[lang].table_empty}
                                                noHeader
                                                pagination
                                                exportHeaders
                                                paginationComponentOptions={defaultComponentOptions}
                                                paginationPerPage={25}
                                                paginationRowsPerPageOptions={[25, 50, 100]}
                                                onRowClicked={(row) => handleRowClick(row.id)}
                                                customStyles={{
                                                    rows: {
                                                        style: {
                                                            cursor: 'pointer',
                                                            minHeight: '24px',
                                                        },
                                                    },
                                                    headCells: {
                                                        style: {
                                                            padding: '2px',
                                                            fontSize: '12px',
                                                            //color:'red',

                                                        },
                                                    },
                                                    cells: {
                                                        style: {
                                                            //color:'red',
                                                            padding: '2px',
                                                            fontSize: '12px',
                                                        },
                                                    },
                                                }}
                                            />
                                        </DataTableExtensions>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </main>
    )
}